import '../styles/main.scss';
import campainCardsSwap from './modules/campaign-cards';
import countUpAnimation from './modules/count-up-animation';
import closeMegamenu from './modules/close-megamenu';
import { fetchitems } from './modules/fetchitems';
import 'what-input';
import yall from 'yall-js';
import 'a11y-toggle';
// import Headroom from 'headroom.js';
import mobileMmenu from './modules/mobile-mmenu';
import contactForms from './modules/contact-forms';
import loadHighlight from './modules/loadHighlight';
import tryoutsTestSubmit from './modules/tryouts-test';
import handleRecaptchav2 from './modules/handleRecaptchav2';
import leftMenu from './modules/left-menu';

const app = () => {
  console.log('App loaded!!');

  yall({
    events: {
      load: function (event) {
        const element = event.target;

        if (!element.classList.contains('lazy') && element.nodeName == 'IMG') {
          element.classList.add('lazy--loaded');
        }
      },
    },
    observeChanges: true,
  });

  campainCardsSwap.init();
  countUpAnimation.init();
  closeMegamenu.init();
  fetchitems.init();
  mobileMmenu.init();
  contactForms.init();
  loadHighlight.init();
  tryoutsTestSubmit.init();
  handleRecaptchav2.init();
  leftMenu.init();
};

// eslint-disable-next-line no-unused-expressions
document.readyState !== 'loading'
  ? app()
  : document.addEventListener('DOMContentLoaded', app);
